import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';
import Modal from '../../molecules/modals/modal';
import { ModalFooter } from '../../molecules/modals/modal-footer';
import {
  ComponentSize,
  ComponentVariant,
} from 'src/modules/shared/types/component.type';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  variant?: ComponentVariant;
  size?: ComponentSize;
  children: React.ReactNode;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
  loading?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  title,
  size = 'md',
  variant = 'primary',
  children,
  onConfirm,
  confirmText,
  cancelText,
  confirmDisabled = false,
  loading = false,
}) => {
  const sizeClasses: Record<ComponentSize, string> = {
    '2xs': 'max-w-xs',
    xs: 'max-w-sm',
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
  };

  const footer = onConfirm ? (
    <ModalFooter
      onCancel={onClose}
      onConfirm={onConfirm}
      cancelText={cancelText}
      confirmText={confirmText}
      confirmDisabled={confirmDisabled}
      loading={loading}
      variant={variant}
    />
  ) : undefined;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={
        title ? (
          <Text size="h6" weight="semibold" className="text-gray-900">
            {title}
          </Text>
        ) : undefined
      }
      body={<div className="py-2">{children}</div>}
      footer={footer}
      dialogClassName={sizeClasses[size]}
    />
  );
};
